import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  DocumentTextIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/outline';
import { PageHeader, TWDataTable } from '../../components/ui';
import { headerCls } from '../../data/columns';
import AgreementViewModal from './components/AgreementViewModal';

const SHELL_CLASS =
  'legal-shell min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8';

// Tek kaynak — ileride tax forms, addenda vb. buraya eklenir.
const DOCUMENTS = [
  {
    key: 'merchant',
    name: 'Merchant Agreement',
    description: 'The Thisway merchant terms your business agreed to.',
    type: 'Agreement',
    termName: 'merchant',
    // Yalnızca en son imzalı sürüm gösterilir; eski kopyalar gizlenir.
    latestOnly: true,
  },
];

const TypeBadge = ({ label }) => (
  <span className="inline-flex items-center rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-medium text-slate-600 dark:bg-slate-700 dark:text-slate-300">
    {label}
  </span>
);

const columns = [
  {
    title: <span className={headerCls}>Document</span>,
    key: 'name',
    render: (_, r) => (
      <div className="flex min-w-0 items-center gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-blue-50 text-blue-600 dark:bg-sky-500/10 dark:text-sky-300">
          <DocumentTextIcon className="h-5 w-5" />
        </span>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">
            {r.name}
          </p>
          <p className="truncate text-xs text-slate-500 dark:text-slate-400">
            {r.description}
          </p>
        </div>
      </div>
    ),
  },
  {
    title: <span className={headerCls}>Type</span>,
    key: 'type',
    render: (_, r) => <TypeBadge label={r.type} />,
  },
  {
    title: '',
    key: 'action',
    align: 'right',
    render: () => (
      <span className="inline-flex items-center gap-1 text-sm font-semibold text-blue-600 dark:text-sky-400">
        View
        <ChevronRightIcon className="h-4 w-4" />
      </span>
    ),
  },
];

const Legal = () => {
  const selectedCompany = useSelector(
    (state) => state.companyReducer.selected,
  );
  const companyId = selectedCompany?.id || '';
  const [modal, setModal] = useState({ open: false, document: null });

  const openDocument = (doc) => setModal({ open: true, document: doc });
  const closeDocument = () => setModal((prev) => ({ ...prev, open: false }));

  return (
    <div className={SHELL_CLASS}>
      <div className="mx-auto max-w-5xl space-y-6">
        <PageHeader
          title="Legal"
          description="Review the agreements and legal documents for your business."
        />

        <TWDataTable
          columns={columns}
          data={DOCUMENTS}
          rowKey="key"
          onRowClick={openDocument}
        />

        <AgreementViewModal
          open={modal.open}
          agreement={modal.document}
          companyId={companyId}
          onClose={closeDocument}
        />
      </div>
    </div>
  );
};

export default Legal;
